import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {
  return (
    <button
      type="submit"
      class={className}
    >
      {text}
    </button>
  );
}
